import { MarketKey } from 'pages/Optimisation/components/ContractedVolume/types';
import { Site } from 'types/site';

export enum TRADE_TYPE {
  Wholesale = 'wholesale',
  Ancillary = 'ancillary',
  BalancingMechanism = 'balancing',
}

export type TradeSideType = 'buy' | 'sell';

export interface IBaseTrade {
  id: number;
  tradeGroupSourceId: number;
  start: Date;
  end: Date;
  power: number;
  price: number;
  side: TradeSideType;
  site: Site;
  market: string;
}

export interface IChartTrade extends Omit<IBaseTrade, 'power' | 'site'> {
  value: number;
  key: MarketKey;
  base?: { start: Date; end: Date };
}
